import { render, staticRenderFns } from "./BackofficeSummary.vue?vue&type=template&id=69abc34e&scoped=true"
import script from "./BackofficeSummary.vue?vue&type=script&lang=js"
export * from "./BackofficeSummary.vue?vue&type=script&lang=js"
import style0 from "./BackofficeSummary.vue?vue&type=style&index=0&id=69abc34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69abc34e",
  null
  
)

export default component.exports